import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import UltimatePagination from 'react-ultimate-pagination-bootstrap-3';

import Comp from 'components/comps/row';
import Loading from 'components/loading_spinner/full_size';
import NoResults from './no_results';

export default function CompSelectorComps({ loading, results, selectedComps, onDeselect, onPageChange, onSelect }) {
  let content;
  if (!results) {
    content = <Loading/>;
  } else if (!results.meta.totalPages) {
    content = <NoResults />;
  } else {
    content = <React.Fragment>
      <div className="comps">
        {results.comps.map(comp => (
          <Comp
            comp={comp}
            key={comp.id}
            selected={selectedComps.map(comp => comp.id).includes(comp.id)}
            onDeselect={onDeselect}
            onSelect={onSelect}
          />
        ))}
      </div>

      <div className="pagination-container">
        <UltimatePagination
          currentPage={results.meta.currentPage}
          totalPages={results.meta.totalPages}
          onChange={onPageChange}
        />
      </div>
    </React.Fragment>;
  }

  return (
    <div className={classNames('comp-selector-comps', { loading: loading && results })}>
      {content}
    </div>
  );
}

CompSelectorComps.propTypes = {
  loading: PropTypes.bool,
  results: PropTypes.shape({
    comps: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
    })).isRequired,
    meta: PropTypes.shape({
      currentPage: PropTypes.number.isRequired,
      totalPages: PropTypes.number.isRequired,
    }).isRequired,
  }),
  selectedComps: PropTypes.arrayOf(PropTypes.object).isRequired,
  onDeselect: PropTypes.func,
  onPageChange: PropTypes.func,
  onSelect: PropTypes.func,
};
